export function verifyNumber(value) {
  var numberRex = new RegExp("^[0-9,]+$");
  if (numberRex.test(value)) {
    return true;
  }
  return false;
}

export function verifyDecimal(value) {
  return !isNaN(parseFloat(value)) && isFinite(value);
}

// function that returns true if value is email, false otherwise
export function verifyEmail(value) {
  var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (emailRex.test(value)) {
    return true;
  }
  return false;
}
// function that verifies if a string has a given length or not
export function verifyLength(value, length, isExact = false) {
  if (isExact) {
    if (parseInt(value.length, 10) === parseInt(length, 10)) {
      return true;
    }
  } else {
    if (value.length >= length) {
      return true;
    }
  }
  return false;
}

export function verifyZip(value) {
  if (verifyNumber(value) && (value.length === 5 || value.length === 9)) {
    return true;
  } else if (value.length === 10 && verifyNumber(value.substring(0, 5)) && verifyNumber(value.substring(6, 10)) && value.substring(5, 6) === '-') {
    return true;
  }
  return false;
}

export function verifyPhone(value) {
  if (value && value.match(/\d/g) && value.match(/\d/g).length === 10) {
    return true;
  }
  return false;
}

export function verifyNumberExactLengthExcludeNonNumeric(value, length) {
  if (value && value.match(/\d/g) && value.match(/\d/g).length === parseInt(length, 10)) {
    return true;
  }
  return false;
}

export function verifyDate(inputDate) {
  var dateArray = inputDate.split('/');
  if (dateArray.length !== 3) {
    dateArray = inputDate.split('-');
    if (dateArray.length !== 3) {
      dateArray = inputDate.split('.');
      if (dateArray.length !== 3) {
        return false;
      }
    }
  }
  if (dateArray.length === 3) {
    var month = dateArray[0]
    var day = dateArray[1]
    var year = dateArray[2]
    var checkMonth = month - 1; //subtract one from the date so it works in js date
    if (year.length === 2) {
      year = '20' + year
    }
    var dateObject = new Date(year, checkMonth, day);
    if (isNaN(dateObject)) {
      return false;
    } else {
      if (month.length === 1) {
        month = '0' + month
      }
      if (day.length === 1) {
        day = '0' + day
      }
      if (year.length === 4 && month.length === 2 && day.length === 2) {
        return year + '-' + month + '-' + day;
      } else {
        return false
      }
    }
  }

}

export function verifyDateOrder(firstDate, secondDate) {

  var firstDateArray = firstDate.split('-');
  var secondDateArray = secondDate.split('-');
  if (firstDateArray.length !== 3 || secondDateArray.length !== 3) {
    return false
  } else {
    var firstDateObject = new Date(firstDateArray[0], firstDateArray[1]-1, firstDateArray[2]);
    var secondDateObject = new Date(secondDateArray[0], secondDateArray[1]-1, secondDateArray[2]);
    if (isNaN(firstDateObject) || isNaN(secondDateObject) || (firstDateObject>secondDateObject)) {
      return false
    }
  }
  return true
}


//from https://github.com/lblima/react-password-strength.git
const hasNumber = value => {
  return new RegExp(/[0-9]/).test(value);
}

const hasMixed = value => {
  return new RegExp(/[a-z]/).test(value) &&
    new RegExp(/[A-Z]/).test(value);
}

const hasSpecial = value => {
  return new RegExp(/[!#@$%^&*)(+=._-]/).test(value);
}

const strengthIndicator = value => {
  let strengths = 0;

  if (value.length > 7)
    strengths++;

  if (hasNumber(value))
    strengths++;

  if (hasSpecial(value))
    strengths++;

  if (hasMixed(value))
    strengths++;

  return strengths;
}

export function verifyPassword(value) {
  const strength = strengthIndicator(value);
  if (strength >= 4) {
    return true;
  }
  return false;
}

export function verifyMatchingNumbers(value1, value2, valueRequired = true) {
  var returnValue = []
  returnValue.matchStatus = ''
  returnValue.showMismatch = ''
  if ((value1 && value1 === value2 && verifyNumber(value1)) ||
    (value1 === '' && value2 === '' && !valueRequired)) {
    returnValue.matchStatus = "success"
    returnValue.showMismatch = false
  } else {
    returnValue.matchStatus = "error"
    if (value1 === value2) {
      returnValue.showMismatch = false
    } else {
      returnValue.showMismatch = true
    }
  }
  return returnValue

}

export function simulateMouseClick(element){
  const mouseClickEvents = ['mousedown', 'click', 'mouseup'];
  if (element) {
    mouseClickEvents.forEach(mouseEventType =>
      element.dispatchEvent(
        new MouseEvent(mouseEventType, {
          view: window,
          bubbles: true,
          cancelable: true,
          buttons: 1
        })
      )
    );
  }
}

export function validateDateFormatAndOrder(startDate, endDate, dateType = '', returnEmptyForError = false) {
  var badDate = ''
  var alertMessage = ''
  var validStartDate = verifyDate(startDate)
  var validEndDate = verifyDate(endDate)


  if (startDate && !validStartDate) {
    badDate += 'start'
  }
  if (endDate && !validEndDate) {
    if (badDate) {
      badDate += ' and '
    }
    badDate += 'end'
  }
  if (badDate) {
    alertMessage = 'Please enter a  valid ' + badDate + ' date'
  } else {
    if (validStartDate && validEndDate && !verifyDateOrder(validStartDate, validEndDate)) {
      alertMessage = 'Please enter a start date that is before the end date'
    }
  }
  if (alertMessage) {
    if (dateType) {
      alertMessage += ' for the ' + dateType
    }
    alertMessage += '.'
  }
  if (returnEmptyForError) {
    if (!validStartDate) {
      validStartDate = ''
    }
    if (!validEndDate) {
      validEndDate = ''
    }
  }

  var returnObject = {
    validStartDate: validStartDate,
    validEndDate: validEndDate,
    alertMessage: alertMessage
  }
  return returnObject
}

export function setToolTipArray(tooltipData) {
  const tooltipArray = {}
  var tooltip = ''
  tooltipData = tooltipData.responseMessage
  const tooltipValues = Object.values(tooltipData)
  for (tooltip of tooltipValues) {
    tooltipArray[tooltip['formKey']] = tooltip['text']
  }
  return tooltipArray
}